"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _useStripeKey = require("../../../src/hooks/use-stripe-key");

var stripePromise = (0, _useStripeKey.useStripeKey)();

var redirectToCheckout =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee(event, props) {
    var details, checkoutResponse, sessionId, stripe, _yield$stripe$redirec, error;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            details = {
              type: props.type,
              code: props.code,
              couponCode: props.couponCode,
              quantity: props.quantity,
              successUrl: props.successUrl,
              cancelUrl: props.cancelUrl,
              submitType: props.submitType,
              langKey: props.langKey
            };
            _context.next = 4;
            return fetch('/.netlify/functions/create-checkout-session', {
              method: 'post',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                details: details
              })
            }).then(function (res) {
              return res.json();
            });

          case 4:
            checkoutResponse = _context.sent;
            sessionId = checkoutResponse.session.id;
            _context.next = 8;
            return stripePromise;

          case 8:
            stripe = _context.sent;
            _context.next = 11;
            return stripe.redirectToCheckout({
              sessionId: sessionId
            });

          case 11:
            _yield$stripe$redirec = _context.sent;
            error = _yield$stripe$redirec.error;

            if (error) {
              console.warn("Error:", error);
            }

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function redirectToCheckout(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var Checkout = function Checkout(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "content",
      style: {
        paddingBottom: '1.5rem'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "button is-dark is-small",
      onClick: function onClick(e) {
        return redirectToCheckout(e, props);
      }
    }, props.label))
  );
};

var _default = Checkout;
exports["default"] = _default;